function initDropdown(btnId: string, listId: string): void {
  const btn = document.getElementById(btnId) as HTMLButtonElement | null
  const list = document.getElementById(listId) as HTMLElement | null
  if (!btn || !list) {
    return
  }

  const chevron = btn.querySelector<HTMLElement>('svg')

  // Prepare list for max-height animation — remove Tailwind's `hidden` and
  // let overflow + max-height handle visibility instead.
  list.classList.remove('hidden')
  list.style.maxHeight = '0'
  list.style.overflow = 'hidden'
  list.style.transition = 'max-height 0.2s ease'

  let isOpen = false

  const close = () => {
    isOpen = false
    list.style.maxHeight = '0'
    list.style.boxShadow = ''
    list.style.border = ''
    btn.setAttribute('aria-expanded', 'false')
    chevron?.classList.remove('rotate-180')
  }

  const open = () => {
    isOpen = true
    list.style.maxHeight = list.scrollHeight + 'px'
    list.style.boxShadow = '0 2px 4px 0 rgba(0,0,0,0.10)'
    list.style.border = '1px solid rgb(229 231 235)'
    btn.setAttribute('aria-expanded', 'true')
    chevron?.classList.add('rotate-180')
    // Move focus to first option
    const first = list.querySelector<HTMLElement>('[role="option"]')
    first?.focus()
  }

  btn.addEventListener('click', (e: MouseEvent) => {
    e.stopPropagation()
    if (isOpen) {
      close()
    } else {
      open()
    }
  })

  list.addEventListener('keydown', (e: KeyboardEvent) => {
    const options = Array.from(list.querySelectorAll<HTMLElement>('[role="option"]'))
    const idx = options.indexOf(document.activeElement as HTMLElement)
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      options[Math.min(idx + 1, options.length - 1)]?.focus()
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault()
      options[Math.max(idx - 1, 0)]?.focus()
    }
    if (e.key === 'Escape') {
      close()
      btn.focus()
    }
  })

  btn.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      close()
    }
  })

  document.addEventListener('click', close)
}

export function initGlobalBanner(): void {
  // ── Language switcher dropdowns (desktop + mobile) ─────────────────────
  initDropdown('lang-switcher-btn', 'lang-switcher-list')
  initDropdown('lang-switcher-btn-mobile', 'lang-switcher-list-mobile')

  // ── Mobile USP cycling ─────────────────────────────────────────────────
  const uspContainer = document.getElementById('usp-mobile') as HTMLElement | null
  const langContainer = document.getElementById('banner-mobile-lang') as HTMLElement | null

  if (uspContainer) {
    const items = uspContainer.querySelectorAll<HTMLElement>('.usp-item')
    if (items.length > 1) {
      let current = 0
      setInterval(() => {
        items[current].classList.remove('opacity-100')
        items[current].classList.add('opacity-0')
        items[current].setAttribute('aria-hidden', 'true')
        current = (current + 1) % items.length
        items[current].classList.remove('opacity-0')
        items[current].classList.add('opacity-100')
        items[current].removeAttribute('aria-hidden')
      }, 3000)
    }
  }

  // ── Swap USPs ↔ lang switcher when mobile menu opens/closes ───────────
  document.addEventListener('banner:menu', (e: Event) => {
    const { open } = (e as CustomEvent<{ open: boolean }>).detail
    if (uspContainer) {
      uspContainer.classList.toggle('hidden', open)
    }
    if (langContainer) {
      langContainer.classList.toggle('hidden', !open)
      langContainer.classList.toggle('flex', open)
    }
  })
}
